export default __webpack_public_path__ + "static/java-865eb0164d668ff7126609fa9159fe50.png";